import React from "react";
import { NavLink as RouterLink, NavLinkProps as RouterLinkProps } from "react-router-dom";
import { NavLink as ThemeUINavLink, NavLinkProps as ThemeUILinkProps } from "theme-ui";

type CombinedProps = ThemeUILinkProps & RouterLinkProps<{}>;

export const ExactLink: React.FC<CombinedProps> = props => {
  return <RouterLink exact {...props} />;
};

export const MenuLink: React.FC<CombinedProps> = (props) => {
  const isExternalLink =
    typeof props.to === "string" && (props.to.startsWith("http://") || props.to.startsWith("https://"));

  if (isExternalLink) {
    return (
      <ThemeUINavLink
        {...props}
        as="a"
        href={typeof props.to === "string" ? props.to : undefined}
        rel="noopener noreferrer"
        target="_self"  // Add this line to open in a new page
        sx={{
          fontFamily: "Arial",
          fontSize: ['10px', '3px', '20px'], 
          textDecoration: "none",
          color: "red",
          textTransform: "none",
          // Add any other custom styling you need here
        }}
      >
        {props.children}
      </ThemeUINavLink>
    );
  } else {
    return (
      <ThemeUINavLink
        {...props}
        as={ExactLink}
        sx={{
          fontFamily: "Arial",
          fontSize: ["10px", "10px", "12px", "14px"], 
          fontWeight: "bold",
          paddingLeft: ["10px", "10px", "12px", "12px"], 
          textDecoration: "none",
          textTransform: "none",
          // Add any other custom styling you need here
        }}
      >
        {props.children}
      </ThemeUINavLink>
    );
  }
};
